import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Deal } from '@services/deals/types/deal';
import { Action } from 'redux';

export class GetOwnerDeals implements LoadingAction {
  readonly type = actions.GET_OWNER_DEALS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public ownerId: string) {}
}

export class GetOwnerDealsSuccess implements LoadingAction {
  readonly type = actions.GET_OWNER_DEALS_SUCCESS;
  readonly isLoading = false;

  constructor(public deals: Deal[]) {}
}

export class GetOwnerDealsError implements ErrorAction {
  readonly type = actions.GET_OWNER_DEALS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetArtistDeals implements LoadingAction {
  readonly type = actions.GET_ARTIST_DEALS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public artistId: string) {}
}

export class GetArtistDealsSuccess implements LoadingAction {
  readonly type = actions.GET_ARTIST_DEALS_SUCCESS;
  readonly isLoading = false;

  constructor(public deals: Deal[]) {}
}

export class GetArtistDealsError implements ErrorAction {
  readonly type = actions.GET_ARTIST_DEALS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ResetDealsState implements Action {
  readonly type = actions.RESET_DEALS_STATE;
}

export type DealsActions =
  | GetOwnerDeals
  | GetOwnerDealsSuccess
  | GetOwnerDealsError
  | GetArtistDeals
  | GetArtistDealsSuccess
  | GetArtistDealsError
  | ResetDealsState;
